import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { getAppThemeName } from '../../../services/appTheme';
const StyledAmount = styled.span `
    display: block;
    color: ${props => {
    if (getAppThemeName() === 'invoned') {
        return props.theme.primary.base;
    }
    return props.theme.primary;
}};
    font-size: 15px;
    font-weight: ${props => (props.appTheme === 'invoned' ? '400' : '600')};
`;
const StatChangedAmount = props => (_jsx(StyledAmount, { ...props, appTheme: getAppThemeName() }));
export default StatChangedAmount;
